import React from "react";
import { BrowserRouter, Routes, Route, Outlet, Navigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import WebDevelopment from "@/pages/WebDevelopment";
import ShopifyDevelopment from "@/pages/ShopifyDevelopment";
import MobileDevelopment from "@/pages/MobileDevelopment";
import UiUxDesign from "@/pages/UiUxDesign";
import CustomApplications from "@/pages/CustomApplications";
import WebsiteSeo from "@/pages/WebsiteSeo";
import WebsiteCare from "@/pages/WebsiteCare";
import ServiceDetail from "@/pages/ServiceDetail";
import Contact from "@/pages/Contact";

function PublicLayout() {
  return (
    <div className="flex flex-col min-h-screen bg-white text-slate-800">
      <Navbar />
      <div className="flex-grow">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* Public Routes with Sticky Glass Navbar and Detailed Footer */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/web-development" element={<WebDevelopment />} />
          <Route path="/services/shopify-development" element={<ShopifyDevelopment />} />
          <Route path="/services/mobile-development" element={<MobileDevelopment />} />
          <Route path="/services/ui-ux-design" element={<UiUxDesign />} />
          <Route path="/services/custom-applications" element={<CustomApplications />} />
          <Route path="/services/websiteseo" element={<WebsiteSeo />} />
          <Route path="/website-care" element={<WebsiteCare />} />
          <Route path="/services/:serviceId" element={<ServiceDetail />} />
          <Route path="/contact-us" element={<Navigate to="/contact" replace />} />
          <Route path="/contact" element={<Contact />} />
        </Route>
        <Route path="/admin/*" element={<Navigate to="/" replace />} />
        <Route path="/login" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
